'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product8__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.q5;
      break;
    }
    case 1: {
      return $thiz.q6;
      break;
    }
    case 2: {
      return $thiz.q7;
      break;
    }
    case 3: {
      return $thiz.q8;
      break;
    }
    case 4: {
      return $thiz.q9;
      break;
    }
    case 5: {
      return $thiz.qa;
      break;
    }
    case 6: {
      return $thiz.qb;
      break;
    }
    case 7: {
      return $thiz.qc;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 7)"));
    }
  }
}
export { $f_s_Product8__productElement__I__O as $f_s_Product8__productElement__I__O };
